import { WorkspaceServiceService } from './../workspace-service.service';
import { Injectable, Inject } from '@angular/core';
import { MenuItem } from '../../components/wolfie-context-menu/menu-item';
import { Subject } from 'rxjs';

type Position = {x: number, y: number};

@Injectable({
  providedIn: 'root'
})
export class WolfieContextMenuService 
{
  //window global vars getters and setters for ease of debugging, and for some reaseon I can't get service work as singleton 
  get items(): MenuItem[]
  {
    return (window as any).wcmItems || [];
  }
  
  set items(value: MenuItem[])
  {
    (window as any).wcmItems = value;
  }

  get menuVisible(): boolean
  {
    return (window as any).wcmMenuVisible || false;
  }

  set menuVisible(value: boolean)
  {
    (window as any).wcmMenuVisible = value;
  }

  get position(): Position
  {
    if((window as any).wcmPosition === undefined)
      (window as any).wcmPosition = {x: 0, y: 0};
    return (window as any).wcmPosition;
  }

  set position(value: Position)
  {
    (window as any).wcmPosition = value;
  }

  get menuOpened(): Subject<void>
  {
    if((window as any).wcmMenuOpened === undefined)
      (window as any).wcmMenuOpened = new Subject();
    return (window as any).wcmMenuOpened;
  } 

  get iconSize(): number
  {
    if((window as any).wcmIconSize == undefined) return 13;
    return (window as any).wcmIconSize;
  }

  set iconSize(value)
  {
    (window as any).wcmIconSize = value;
  }

  get mobile()
  {
    return this.workspaceService.data.mobileMode != 'desktop';
  }

  title? = '';

  constructor(@Inject(WorkspaceServiceService) private workspaceService: WorkspaceServiceService) 
  {
    this.hide();
    this.patchDocumentOnClick();
  }

  show(position: Position, items: MenuItem[], title?: string, iconSize = 13)
  {
    this.title = title;
    this.iconSize = iconSize;
    this.items = items;
    this.position = position;
    this.menuVisible = true;
    this.menuOpened.next();
  }

  hide()
  {
    this.menuVisible = false;
  }

  private patchDocumentOnClick()
  {
    let onClick = document.onclick;
    let that = this;
    document.onclick = function(this: GlobalEventHandlers, ev: MouseEvent) 
    { 
      if(onClick != null)
        onClick.call(this, ev);

      if(that.mobile)
        return;
      
      if(that.menuVisible)
        that.hide();
    };
  }
}
